// extracted by mini-css-extract-plugin
module.exports = {"nft":"index_nft___kuz1"};